<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center">
        <v-col xs="12" sm="8" md="6" lg="4" xl="3">
          <v-card class="elevation-12 mt-5">
            <v-toolbar dark color="primary" src="/assets/bg.jpg">
              <v-toolbar-title>{{ $t("login.title") }}</v-toolbar-title>
            </v-toolbar>
            <v-form @submit.prevent="submit" ref="form" v-model="valid">
              <v-card-text>
                <v-text-field
                  prepend-icon="mdi-account"
                  :label="$t('login.username')"
                  name="username"
                  v-model="username"
                  required
                  :rules="[$v.required(), $v.isEmail()]"
                ></v-text-field>
                <v-text-field
                  prepend-icon="mdi-key"
                  :label="$t('login.password')"
                  name="password"
                  type="password"
                  v-model="password"
                  required
                  :rules="[$v.required()]"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" :disabled="!valid" color="primary">{{ $t("login.submit") }}</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    valid: false,
    username: "",
    password: "",
  }),
  methods: {
    async submit() {
      if (!this.$data.valid) return;
      const auth = await axios.post("/login", {
        username: this.username,
        password: this.password,
      });
      await this.$store.dispatch("AUTHENTICATE", auth);
      this.$router.push(this.$route.query.redirect || "/");
    },
  },
};
</script>
